
import React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface StyledBadgeProps {
  value: string;
  variant?: "default" | "blue" | "green" | "purple" | "dark" | "primary" | "yellow" | "outline";
  className?: string;
  extraSmall?: boolean;
}

export const StyledBadge = ({ value, variant = "default", className, extraSmall = false }: StyledBadgeProps) => {
  const badgeVariants: Record<string, string> = {
    default: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300",
    blue: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
    green: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
    purple: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
    dark: "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300",
    primary: "bg-primary/10 text-primary dark:bg-primary/20",
    yellow: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
    outline: "bg-transparent border border-gray-300 text-gray-800 dark:border-gray-600 dark:text-gray-300"
  };

  const badgeClass = badgeVariants[variant] || badgeVariants.default;

  return (
    <Badge 
      className={cn(
        "font-normal", 
        badgeClass,
        extraSmall && "text-xs py-0 px-1.5",
        className
      )}
      variant="outline"
    >
      {value}
    </Badge>
  );
};
